module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/block-capacity-box/block-capacity-box.component.scss
// module id = ./src/app/modules/common-module/common/block-capacity-box/block-capacity-box.component.scss
// module chunks = 9